module.exports = __webpack_public_path__ + "media/entities/2203-f40de4b5.png";